module.exports = __webpack_public_path__ + "img/pic_uk_06.7dfeec68.jpg";